<template>
    <div>
        <div class="rootdiv" v-loading="loading">

            <topmenu></topmenu>


            <div class="container theme-showcase">
                <div style="margin-top: 20px; display: flex; align-items: center;">
                    <div style="display: flex; flex:1;">
                        <div style="margin-right: 12px;">
                            <el-button type="primary" icon="el-icon-plus" size="medium" @click="add">添加</el-button>
                        </div>
                        <div>
                            <el-select v-model="shopid" size="medium" placeholder="Select" @change="eventChange"
                                style="width: 150px;">
                                <el-option v-for="item in shoplist" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div style="margin-left: 12px;">
                            <el-select v-model="handlestatus" size="medium" placeholder="Select" @change="eventChange"
                                style="width: 100px;">
                                <el-option v-for="item in handleStatusList" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div style="margin-left: 12px;">
                            <el-select v-model="categorystr" size="medium" placeholder="Select" @change="eventChange"
                                style="width: 120px;">
                                <el-option v-for="item in categorylist2" :key="item.id" :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>
                        </div>
                        <!-- <div style="margin-left: 12px;">
                            <el-select v-model="eventId" size="medium" placeholder="Select" @change="eventChange"
                                style="width: 120px;">
                                <el-option v-for="item in eventList" :key="item.id" :label="item.nickname"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div> -->
                    </div>
                    <div style="display: flex;">
                        <div>
                            <el-input v-model="searchtxt" placeholder="请输入" clearable autofocus
                                @keyup.enter.native="loadData" @input="inputChange"></el-input>
                        </div>
                        <div style="margin-left: 20px;">
                            <el-button icon="el-icon-search" @click="loadData" type="primary">搜索</el-button>
                        </div>
                    </div>
                </div>

                <div style="margin: 16px 0;">
                    <el-table :data="list" border style="width: 100%">
                        <el-table-column prop="index" label="序号" width="50" fixed="left">
                        </el-table-column>
                        <el-table-column prop="CreateWxUserName" label="昵称" min-width="100" width="100">
                            <template slot-scope="scope2">
                                <div>
                                    <span v-if="!scope2.row.ourcreate">{{ scope2.row.CreateWxUserName }}</span>
                                    <span v-if="scope2.row.ourcreate">{{ scope2.row.CreateWxUserName }}
                                        <div style="color: #409EFF; font-size: 14px; ">(后台添加)</div>
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="CreateTime" label="提交时间" min-width="100" width="100">
                        </el-table-column>
                        <el-table-column prop="ContentTxt" label="内容" min-width="150">
                            <template slot-scope="scope2">
                                <div>
                                    <el-tooltip class="item" effect="dark" content="点击查看详情" placement="top">
                                        <div style="cursor: pointer;" class="ellipsis-container"
                                            @click="showdetails(scope2.$index, scope2.row)">
                                            <span v-if="scope2.row.Category" style="color:#409EFF;">[{{
                                                scope2.row.Category }}]</span>
                                            <span v-if="scope2.row.ImgUrls.length > 0"
                                                style="color:#f56c6c;">[有图]</span>{{ scope2.row.ContentTxt }}
                                        </div>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ShopName" label="门店" min-width="100">
                        </el-table-column>
                        <el-table-column prop="IsShow" label="是否显示" min-width="50">
                            <template slot-scope="scope2">

                                <!-- <el-tag v-if="scope.row.IsShow">显示</el-tag>
        <el-tag type="info" v-if="!scope.row.IsShow">不显示</el-tag> -->
                                <el-switch v-model="scope2.row.Show" v-if="showIsShowBtn" @change="swithcChange(scope2.$index, scope2.row)">
                                </el-switch>
                                <div>
                                    <span v-if="scope2.row.IsShow == 1" style="color: #409EFF;">显示</span>
                                    <span v-if="scope2.row.IsShow != 1">不显示</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="HandleTxt" label="回复内容" min-width="100">
                            <template slot-scope="scope">
                                <div v-if="scope.row.HandleTxt">
                                    <el-tooltip class="item" effect="dark" content="点击查看详情" placement="top">
                                        <div style="cursor: pointer;" class="ellipsis-container"
                                            @click="showdetails(scope.$index, scope.row)">
                                            {{ scope.row.HandleTxt }}
                                        </div>
                                    </el-tooltip>
                                </div>

                                <el-button type="success" v-else @click="report(scope.$index, scope.row)"
                                    size="mini">点击回复</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="HandleTime" label="回复时间" min-width="100" width="100">
                        </el-table-column>
                        <el-table-column prop="HandleUserName2" label="回复人" min-width="60">
                        </el-table-column>



                        <!-- <el-table-column label="Edit" fixed="right" min-width="80">
                            <template slot-scope="scope">
                                <el-button type="primary" icon="el-icon-edit" circle
                                    @click="handleEdit(scope.$index, scope.row)" size="mini"></el-button>
                                <el-button type="danger" icon="el-icon-delete" circle
                                    @click="handleDelete(scope.$index, scope.row)" size="mini"></el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <div style="margin:12px 0;">
                        <div v-if="total > 8">
                            <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                                page-size="8" :current-page.sync="currentPage" :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>


                <el-dialog title="回复" :visible.sync="showReportDialog" width="650px">
                    <el-form :model="form" label-width="120px">
                        <el-form-item label="类型:" required :error="addNameErr">


                            <el-select v-model="categoryId" size="medium" placeholder="Select" style="width: 120px;">
                                <el-option v-for="item in categorylist" :key="item.id" :label="item.name"
                                    :value="item.name">
                                </el-option>
                            </el-select>

                        </el-form-item>
                        <el-form-item label="处理人:" required :error="reportUserErr" >
                            <el-input v-model="reportUser" readonly></el-input>
                        </el-form-item>
                        <el-form-item label="回复内容:" required :error="reportContentErr">
                            <el-input v-model="reportContent" type="textarea" :rows="10"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showReportDialog = false">取消</el-button>
                        <el-button type="primary" @click="submitReport">确定</el-button>
                    </div>
                </el-dialog>


                <el-dialog title="新建" :visible.sync="dialogFormVisible" width="650px">
                    <el-form :model="form" label-width="120px">
                        <el-form-item label="顾客昵称:" required :error="addNameErr">
                            <el-input v-model="addName"></el-input>
                        </el-form-item>
                        <el-form-item label="提交时间:" required :error="addReporttimeErr">
                            <el-date-picker v-model="addReporttime" type="datetime" placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="所属门店:" required :error="addShopIdErr">
                            <div style="display: flex;">
                                <el-select v-model="addShopId" size="medium" placeholder="Select">
                                    <el-option v-for="item in shoplist" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item label="建议内容:" required :error="addContentErr">
                            <el-input v-model="addContent" type="textarea" :rows="6"></el-input>
                        </el-form-item>
                    </el-form>
                    <!-- <div>
                    <el-upload class="avatar-uploader"
  action="https://jsonplaceholder.typicode.com/posts/"
  list-type="picture-card"
  :on-preview="handlePictureCardPreview"
  :on-remove="handleRemove">
  <i class="el-icon-plus"></i>
</el-upload>
                </div> -->
                    <div style="display: flex;">
                        <div style="width: 108px; padding-right: 12px; text-align: right; ">上传照片:</div>
                        <div style="display: flex; align-items:center;">
                            <div>
                                <el-upload class="avatar-uploader" :class="{ hide: hideUploadBtn }" action="#"
                                    :http-request="topimgUpload" :limit="3" list-type="picture-card"
                                    :file-list="fileList" :on-exceed="handleExceed" :on-change="handleEditChange"
                                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                                    :before-remove="beforeRemove">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取消</el-button>
                        <el-button type="primary" @click="submit">确定</el-button>
                    </div>
                </el-dialog>

                <el-dialog :visible.sync="dialogVisible">
                    <div style="border:1px gray solid;">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </div>
                </el-dialog>

                <el-dialog :visible.sync="showDetailsDialog">
                    <div class="detailsdiv">
                        <div class="detailsdivl">Id:</div>
                        <div class="detailsdivr">{{ this.did }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">昵称:</div>
                        <div class="detailsdivr">{{ this.dnickname }}<span v-if="dourcreate"
                                style="color:#409EFF">(后台添加)</span></div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">手机号:</div>
                        <div class="detailsdivr">{{ this.dWxUserTel }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">提交时间:</div>
                        <div class="detailsdivr">{{ this.dCreateTime }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">门店:</div>
                        <div class="detailsdivr">{{ this.dShopName }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">反馈内容:</div>
                        <div class="detailsdivr" style="white-space: pre-wrap;">{{ this.dContentTxt }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">图片:</div>
                        <div class="detailsdivr">
                            <div style="display: flex;">
                                <div v-for="item in dImgUrls" :key="item"
                                    style="margin-right:12px; border:1px #f1f1f1 solid;">
                                    <img :src="item" style="width:100px; height: 100px; cursor: pointer;"
                                        @click="showImg(item)" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="margin:10px 0; border-top: 1px #d1d1d1 dashed;"></div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">是否显示:</div>
                        <div class="detailsdivr">{{ this.dShow }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">类别:</div>
                        <div class="detailsdivr">{{ this.dCategory }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">回复内容:</div>
                        <div class="detailsdivr" style="white-space: pre-wrap;">{{ this.dHandleTxt }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">回复时间:</div>
                        <div class="detailsdivr">{{ this.dHandleTime }}</div>
                    </div>

                    <div class="detailsdiv">
                        <div class="detailsdivl">回复人:</div>
                        <div class="detailsdivr">{{ this.dHandleUserName }}<span style="color:#409EFF;">({{
                                this.dHandleUserName2
                                }})</span></div>
                    </div>

                    <!-- <div class="detailsdiv">
                        <div class="detailsdivl">:</div>
                        <div class="detailsdivr">{{ this.did }}</div>
                    </div> -->

                    <div v-if="showReportSuggestionBtn">
                    <div v-if="this.dHandleTime" style="text-align: center; margin-top:15px;">
                        <el-button type="primary" @click="editReport(did)">修改</el-button>
                    </div>
                    <div v-else style="text-align: center; margin-top:15px;">
                        <el-button type="success" @click="subReport(did)">回复</el-button>
                    </div>
                    </div>

                </el-dialog>

            </div>
        </div>
    </div>

</template>

<script>
import axios from 'axios'
import topmenu from '../home/components/topmenu'
import scope from 'stylus/lib/stack/scope';

export default {
    name: 'emailtemplist',
    components: { topmenu },
    data() {
        return {
            form: {},
            loading: false,
            eventId: 0,
            list: [],
            eventList: [{ id: 0, nickname: '全部' }],
            searchtxt: '',
            handlestatus: '',
            handleStatusList: [{ id: '', name: '全部' }, { id: '1', name: '未回复' }, { id: '2', name: '已回复' }],
            dialogFormVisible: false,
            reporttime: '',
            shoplist: [],
            dialogImageUrl: '',
            dialogVisible: false,
            hideUploadBtn: false,
            fileList: [],
            fileIds: [],
            addName: "",
            addNameErr: "",
            addReporttime: '',
            addReporttimeErr: '',
            addShopId: '',
            addShopIdErr: '',
            addContent: '',
            addContentErr: '',
            showReportDialog: false,
            reportId: '',
            // categorylist: [{ id: 1, name: "商品" }, { id: 2, name: "表扬" }, { id: 3, name: "建议" }, { id: 4, name: "咨询" }],
            categorylist: [],
            categoryId: '商品',
            reportUser: '',
            reportUserErr: '',
            reportContentErr: '',
            reportContent: '',
            currentPage: 1,
            shopid: 0,
            showDetailsDialog: false,
            detailsId: 0,
            // categorylist2: [{ id: 0, name: "全部" },{ id: 1, name: "商品" }, { id: 2, name: "表扬" }, { id: 3, name: "建议" }, { id: 4, name: "咨询" }],
            categorylist2: [],
            categorystr: '全部',
            total: 0,
            did: '',
            dContentTxt: '',
            dShopName: '',
            dImgUrls: '',
            dShow: '',
            dHandleTime: '',
            dHandleUserName2: '',
            dHandleUserName: '',
            dHandleTxt: '',
            dCategory: '',
            dCreateTime: '',
            dWxUserTel: '',
            dourcreate: '',
            dnickname: '',
            pageSize: 0,
            showIsShowBtn: false
        }
    },
    methods: {
        subReport(id) {
            console.log(id);
            this.showDetailsDialog = false;
            this.showReportDialog = true;
            this.reportContent = '';
            this.reportId = id;
            
        var userJson = JSON.parse(localStorage.getItem('userJson'));
        this.reportUser = userJson["nickname"];
        },
        editReport(id) {
            console.log(id);
            this.showDetailsDialog = false;
            this.showReportDialog = true;
            var item = "";
            for (var i in this.list) {
                if (this.list[i]["Id"] == id) {
                    item = this.list[i];
                }
            }
            console.log(item);
            this.reportId = id;
            this.reportContent = item["HandleTxt"];
            this.categoryId = item["Category"];
            // this.reportUser = item["HandleUserName2"];
            
        var userJson = JSON.parse(localStorage.getItem('userJson'));
        this.reportUser = userJson["nickname"];
        },
        submitReport() {
            console.log(this.fileIds);
            if (this.reportUser == '') {
                this.reportUserErr = "请输入";
                return;
            } else {
                this.reportUserErr = "";
            }
            if (this.reportContent == '') {
                this.reportContentErr = "请输入";
                return;
            } else {
                this.reportContentErr = "";
            }

            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/reportSuggestion',
                {
                    id: this.reportId,
                    category: this.categoryId,
                    reporter: this.reportUser,
                    content: this.reportContent,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.reportSucc)
        },
        reportSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.showReportDialog = false;
                this.loadData();
                this.$message({
                    message: '回复成功!',
                    type: 'success',
                    onClose: () => {
                    }
                });
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        submit() {
            console.log(this.fileIds);
            if (this.addName == '') {
                this.addNameErr = "请输入";
                return;
            } else {
                this.addNameErr = "";
            }
            if (this.addReporttime == '') {
                this.addReporttimeErr = "请选择";
                return;
            } else {
                this.addReporttimeErr = "";
            }
            if (this.addShopId == '') {
                this.addShopIdErr = "请选择";
                return;
            } else {
                this.addShopIdErr = "";
            }
            if (this.addContent == '') {
                this.addContentErr = "请输入";
                return;
            } else {
                this.addContentErr = "";
            }


            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/addSuggestion',
                {
                    ShopId: this.addShopId,
                    Content: this.addContent,
                    ImgIds: this.fileIds,
                    uid: userJson.uid,
                    token: userJson.token,
                    WxUserName: this.addName,
                    addReporttime: this.addReporttime,
                }
            )
                .then(this.addSucc)
        },
        addSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData();
                this.dialogFormVisible = false;
                this.$message({
                    message: '添加成功!',
                    type: 'success',
                    onClose: () => {
                    }
                });
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        changeshow(id, show) {
            this.loading = true;
            show = show ? 0 : 1;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/changeShow',
                {
                    uid: userJson.uid,
                    token: userJson.token,
                    id: id,
                    show: show
                }
            )
                .then(this.changeshowSucc)
        },
        changeshowSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData();
                this.$message({
                    message: '修改成功!',
                    type: 'success',
                    onClose: () => {
                    }
                });
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        handleEditChange(file, fileList) {
            this.hideUploadBtn = fileList.length >= 3;
        },
        topimgUpload(data) {
            this.loading = true;
            var formData = new FormData();
            formData.append("file", data.file);
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            console.log(userJson);
            var uid = userJson.uid;
            var token = userJson.token;
            console.log(uid);
            console.log(token);
            axios.post('api/UploadFile/UpLoadOneImg?uid=' + uid + '&token=' + token + '&type=110',
                formData
            )
                .then(this.topimgUploadSucc)
        },
        topimgUploadSucc(res) {
            res = res.data
            console.log(res);
            this.loading = false;
            if (res && res.Code == 200) {
                this.topimg = res.fileUrl;
                this.fileIds.push(res.fileId);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        handleExceed(files, fileList) {

            console.log(files, fileList);
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.hideUploadBtn = fileList.length >= 6;
        },
        beforeRemove(file, fileList) {
            console.log(file.uid);
            console.log(fileList);
            var uid = file.uid;
            var index = fileList.findIndex(item => item.uid == uid)
            console.log(index);
            this.fileIds.splice(index, 1);
            console.log("此时的id数组：", this.fileIds);
        },
        handlePictureCardPreview(file) {
            console.log(file);
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        showImg(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true;
        },

        handleCurrentChange(page) {
            console.log(page)
            this.loadData(page);
        },

        add() {
            this.dialogFormVisible = true;
            this.id = '';
            this.addName = "";
            this.addReporttime = '';
            this.addShopId = '';
            this.addContent = '';
            this.fileIds = [];
            this.fileList = [];
        },
        report(index, row) {
            console.log('report');
            console.log(index, row);
            this.reportId = row["Id"];
            this.showReportDialog = true;
            this.reportContent = '';
            
        var userJson = JSON.parse(localStorage.getItem('userJson'));
        this.reportUser = userJson["nickname"];
        },
        showdetails(index, row) {
            console.log('report');
            console.log(index, row);
            this.detailsId = row["Id"];
            this.showDetailsDialog = true;
            this.did = row["Id"];
            this.dnickname = row["CreateWxUserName"];
            this.dourcreate = row["ourcreate"];
            this.dCreateTime = row["CreateTime"];
            this.dShopName = row["ShopName"];
            this.dContentTxt = row["ContentTxt"];
            this.dImgUrls = row["ImgUrls"];
            this.dWxUserTel = row["WxUserTel"];
            this.dShow = row["Show"] ? '显示' : '不显示';
            this.dHandleTxt = row["HandleTxt"];
            this.dHandleTime = row["HandleTime"];
            this.dHandleUserName = row["HandleUserName"];
            this.dHandleUserName2 = row["HandleUserName2"];
            this.dCategory = row["Category"];
        },
        swithcChange(index, row) {
            console.log(index, row);
            var show = row["Show"];
            var id = row["Id"];
            console.log(show, id);
            var txt = '显示';
            if (!show) {
                txt = '隐藏';
            }
            this.$confirm('确认' + txt + '吗？')
                .then(_ => {
                    console.log("确定按钮" + show)
                    show = !show;
                    this.changeshow(id, show);
                    done();
                })
                .catch(_ => {
                    console.log("取消了")
                    this.list[index]["Show"] = !show;
                });
        },
        loadData(refresh) {
            console.log("搜索")
            this.loading = true;
            var page = this.currentPage == null ? 1 : this.currentPage;
            if (refresh == 1) {
                page = 1;
            }
            var search = this.searchtxt;
            var handerid = this.eventId;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/ManageSuggestionList',
                {
                    skip: (page - 1) * 8,
                    limit: 8,
                    search: search,
                    handerid: handerid,
                    handled: this.handlestatus,
                    shopid: this.shopid,
                    category: this.categorystr,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.total = res.total;
                this.list = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        loadShop() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/ShopList',
                {
                    skip: 0,
                    limit: 100,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadShopSucc)
        },
        loadShopSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                var shoplist = res.list;
                shoplist.unshift({ id: 0, name: '全部' });
                this.shoplist = shoplist;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        // add() {
        //     this.$router.push('/addbadge?eid=' + this.eventId);
        // },
        loadCategory() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/CategoryList',
                {
                    skip: 0,
                    limit: 10000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadCategorySucc)
        },
        loadCategorySucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if (res.list && res.list.length > 0) {
                    this.categorylist = res.list;
                    this.categorylist2 = [...res.list];  // 创建新数组
                    this.categorylist2.unshift({ id: 0, name: '全部' });
                    console.log(this.CategoryList2);
                    this.categoryId = res.list[0]["name"];
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        loadEvent() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/User/userList',
                {
                    limit: 10000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadEventSucc)
        },
        loadEventSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if (res.list && res.list.length > 0) {
                    this.eventList = res.list;
                    //console.log(this.eventList);
                    this.eventList.unshift({ id: 0, nickname: '全部' });
                    console.log(this.eventList);
                    this.loadData(1);
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        eventChange(id) {
            console.log(id);
            this.loadData(1);
        },
        handleEdit(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);
            this.$router.push('/addbadge?eid=' + this.eventId + '&id=' + id);
        },
        handleDelete(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);

            this.$confirm('This will permanently delete the data. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.delCate(id);
            });

        },

        delCate(id) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Badge/delete',
                {
                    id: id,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.delCateSucc)
        },
        delCateSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData();
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        inputChange(val) {
            console.log(val);
        },
    },
    mounted() {

        var userJson = JSON.parse(localStorage.getItem('userJson'));
        this.reportUser = userJson["nickname"];
        console.log(userJson["nickname"])
        this.permissions = userJson['permissions'];
        var showIsShowBtn = this.showIsShowBtn;
        var showReportSuggestionBtn = this.showReportSuggestionBtn;
 for(var i =0;i<this.permissions.length;i++){
            var permission = this.permissions[i]['code'];
            if(permission == "ShowSuggestion"){
                showIsShowBtn=true;
            }
            if(permission == 'ReportSuggestion'){
                showReportSuggestionBtn=true;
            }
        }
        this.showIsShowBtn = showIsShowBtn;
        this.showReportSuggestionBtn=showReportSuggestionBtn;
        this.loadCategory();
        this.loadEvent();
        this.loadShop();
    },
    beforeDestroy() {

    }
}
</script>


<style scoped>
.rootdiv>>>.topmenuitem:nth-child(1) {
    color: #fff;
    background-color: #080808;
}

.rootdiv>>>.el-table .el-table__cell {
    padding: 10px 0;
}

.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader>>>.el-upload--picture-card {
    width: 68px !important;
    height: 68px !important;
    line-height: 68px;
}

.avatar-uploader>>>.el-upload-list__item {
    width: 68px;
    height: 68px;
}

.ellipsis-container {
    /* width: 200px; */
    display: -webkit-box;
    -webkit-line-clamp: 3;
    /* 限制显示的行数为3 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}


.avatar-uploader>>>.el-upload {}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 68px !important;
    height: 68px !important;
    line-height: 68px;
    text-align: center;
}

.avatar {
    width: 68px;
    display: block;
}

.hide {
    .el-upload--picture-card {
        display: none !important;
    }
}

.detailsdiv {
    display: flex;
    margin-bottom: 10px;
}

.detailsdivl {
    width: 120px;
    text-align: right;
    margin-right: 10px;
    font-weight: bold;
}

.detailsdivr {
    flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/badgelist/badgelist.vue